import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** shadcn/ui 标配工具: 合并 tailwind class, 去重冲突 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
